import React from 'react';
import { Button } from '@os/components/ui/button';
import { Save, FolderOpen, FileText, Download, Printer } from 'lucide-react';

type Props = {
  isSaving: boolean;
  isLoading: boolean;
  onNew: () => void;
  onOpen: () => void;
  onSave: () => void;
  onSaveAs: () => void;
  onExportHtml: () => void;
  onExportText: () => void;
  onPrint: () => void;
  onExportDocx: () => void;
};

const MapleWordHeaderActions: React.FC<Props> = ({ isSaving, isLoading, onNew, onOpen, onSave, onSaveAs, onExportHtml, onExportText, onPrint, onExportDocx }) => {
  return (
    <div className="flex items-center gap-2 flex-wrap mb-2">
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onNew(); }} size="sm" variant="outline">
        <FileText className="w-4 h-4 mr-1" />
        New
      </Button>
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onOpen(); }} size="sm" variant="outline" disabled={isLoading}>
        <FolderOpen className="w-4 h-4 mr-1" />
        {isLoading ? 'Loading...' : 'Open'}
      </Button>
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onSave(); }} size="sm" variant="outline" disabled={isSaving}>
        <Save className="w-4 h-4 mr-1" />
        {isSaving ? 'Saving...' : 'Save'}
      </Button>
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onSaveAs(); }} size="sm" variant="outline">
        <Save className="w-4 h-4 mr-1" />
        Save As
      </Button>

      <div className="h-6 w-px bg-border mx-2" />

      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onExportHtml(); }} size="sm" variant="outline">
        <Download className="w-4 h-4 mr-1" />
        Export HTML
      </Button>
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onExportText(); }} size="sm" variant="outline">
        <Download className="w-4 h-4 mr-1" />
        Export Text
      </Button>
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onExportDocx(); }} size="sm" variant="outline">
        <Download className="w-4 h-4 mr-1" />
        Export Word
      </Button>
      <Button type="button" onMouseDown={(e) => { e.preventDefault(); onPrint(); }} size="sm" variant="outline">
        <Printer className="w-4 h-4 mr-1" />
        Print
      </Button>
    </div>
  );
};

export default MapleWordHeaderActions;